import { Button, HeroBackground } from '@prishapolicy/shared/ui';
import { growthIcon } from '@prishapolicy/w3/assets';
import { NextSeo } from 'next-seo';
import Image from 'next/image';

export const AboutPospBanner = () => {
  return (
    <div className="mb-5">
      <NextSeo
        title="About Your POSP | PrishaPolicy"
        description="Become a PrishaPolicy POSP insurance agent, start with zero investment and build your own insurance business with training and support."
      />
      <HeroBackground backgroundColor="blue-200" className="lg:pb-4">
        <div className="flex items-center">
          <div>
            <h1 className="text-title-6 md:text-title-3 lg:text-title-3 font-medium">Be your own Boss</h1>
            <h1 className="text-[40px] font-bold md:text-[60px] lg:text-[60px]">Start with ZERO Investment</h1>
            <h1 className="text-body-1 md:text-title-2 lg:text-title-3 mb-8 font-normal">Become a POSP Agent today</h1>
            <div className="block sm:flex">
              <Button
                text="Become a POSP"
                color="white"
                rightIcon="arrowRight"
                variant="secondary"
                size="large"
                className="mb-2 sm:mb-0"
                href="#become-a-posp"
              />
            </div>
          </div>
          <div className="mb-8 hidden  lg:block">
            <Image src={growthIcon} width={500} height={500} alt="growth icon" />
          </div>
        </div>
      </HeroBackground>
    </div>
  );
};
